import clsx from 'clsx';
import './footer.scss';
import { useEffect, useRef } from 'react';
import gsap from 'gsap';
export default function Footer({ isHide }: { isHide: boolean }) {
  const shareImage = [
    {
      id: 4,
      channel_name: 'TAP',
      channel_image:
        'https://cwmsimage.cmge.com/xjimage//uploads/d00fca9c29da2bf3dfcfa018f68b6e6a.png',
      jump_url: 'https://l.taptap.cn/vVynG45v?channel=rep-rep_lfnvwybk9xk',
      image_url: '',
    },
    {
      id: 6,
      channel_name: '公众号',
      channel_image:
        'https://cwmsimage.cmge.com/xjimage//uploads/93f11f6aca879eba967635a75b880d1b.png',
      jump_url: '',
      image_url:
        'https://cwmsimage.cmge.com/xjimage//uploads/08817661d26b427e6e54cbeea5922b8e.jpg',
    },
    {
      id: 5,
      channel_name: 'B站',
      channel_image:
        'https://cwmsimage.cmge.com/xjimage//uploads/8e88c511f2f0c674571da87b90118429.png',
      jump_url:
        'https://www.biligame.com/detail/?id=109365&sourceFrom=2000040011&spm_id_from=333.337.0.0',
      image_url: '',
    },
    {
      id: 2,
      channel_name: '微博',
      channel_image:
        'https://cwmsimage.cmge.com/xjimage//uploads/4e6f66306cf8b041cde1729fa5653403.png',
      jump_url: 'https://weibo.com/u/7766148327',
      image_url: '',
    },
    {
      id: 9,
      channel_name: '抖音',
      channel_image:
        'https://cwmsimage.cmge.com/xjimage//uploads/ab9dcad78b30b6f9bb93d30402734d6a.png',
      jump_url: '',
      image_url:
        'https://cwmsimage.cmge.com/xjimage//uploads/c5787439148530f6cbf3b4d7a2abcd27.png',
    },
    {
      id: 1,
      channel_name:
        '《仙剑世界》玩家群1,《仙剑世界》玩家群2,《仙剑世界》玩家群6,《仙剑世界》玩家群3,《仙剑世界》玩家群11',
      channel_image:
        'https://cwmsimage.cmge.com/xjimage//uploads/dbb77ebd9fbafd4b523bd0e8d3495f75.png',
      jump_url: '',
      image_url:
        'https://cwmsimage.cmge.com/xjimage//uploads/f0689c72b860199a1d2df20fdf04e631.png',
    },
    {
      id: 8,
      channel_name: '小红书',
      channel_image:
        'https://cwmsimage.cmge.com/xjimage//uploads/5353cf73808eb0204fe7ca08f90b24ab.png',
      jump_url: '',
      image_url:
        'https://cwmsimage.cmge.com/xjimage//uploads/63282f085f607c347d4256e432311f4c.png',
    },
    {
      id: 7,
      channel_name: '仙盟',
      channel_image:
        'https://cwmsimage.cmge.com/xjimage//uploads/603121822e966bff97c2872df7b997cd.png',
      jump_url: '',
      image_url:
        'https://cwmsimage.cmge.com/xjimage//uploads/f3fba445c7c2b2ee57e1737df900bd0e.jpg',
    },
  ];

  const tolink = (channel: string, link: string | undefined) => {
    link && window.open(link, '_blank');
  };

  const tween = useRef<gsap.core.Tween>();
  const elRef = useRef(null);
  useEffect(() => {
    if (tween.current) tween.current.kill();
    if (isHide) {
      tween.current = gsap.to(elRef.current, {
        y: '100%',
        opacity: 0,
        ease: 'power3.out',
      });
    } else {
      tween.current = gsap.to(elRef.current, {
        y: '0',
        opacity: 1,
        ease: 'power3.out',
      });
    }
  }, [isHide]);

  return (
    <section
      className={clsx([
        'footer_wrapper absolute w-screen bottom-0 z-5 overflow-visible',
        isHide && 'pointer-events-none',
      ])}
      ref={elRef}
    >
      <div className="absolute top-0 left-0 flex items-center px-[66rem] w-full h-full box-border">
        {/* 左 */}
        <div className="w-auto h-auto">
          {/* log */}
          <div className="flex items-center">
            <div className="text-[#464646] text-[14rem]  text-left">
              <p>EARTJ:</p>
              <p>REVIVAL</p>
            </div>
            <div className="ml-[18rem] w-[100rem] h-[67rem]">
              <div className="zsy_logo w-full h-full"></div>
            </div>
            <div className="flex mt-[10rem] ml-[20rem] space-x-[20rem]">
              {shareImage.map((item, index) => (
                <div
                  key={index}
                  rel="noreferrer"
                  className="qrcodeWrapper relative cursor-pointer"
                  onClick={() => {
                    tolink(
                      item.channel_name,
                      item.image_url === '' ? item.jump_url : ''
                    );
                  }}
                >
                  <div className="w-[43rem] h-[42rem]">
                    <img
                      className="w-full h-full"
                      src={item.channel_image}
                      width={88}
                      height={86}
                      alt={item.channel_image}
                    />
                  </div>
                  {item.image_url !== '' && (
                    <div className="qrcode absolute top-0 left-1/2 -translate-y-[115%] -translate-x-1/2 w-[160rem] h-[160rem] shadow-sm">
                      <img
                        className="w-full h-full"
                        src={item.image_url}
                        width={160}
                        height={160}
                        alt={item.image_url}
                      />
                      <div
                        className="absolute bottom-0 left-1/2 translate-y-[49%] -translate-x-1/2 w-[10rem] h-[10rem] -rotate-45"
                        style={{
                          background:
                            'linear-gradient(45deg, white, white 50%, transparent 50%, transparent 100%)',
                        }}
                      ></div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          {/* 工商 */}
          <div className="flex items-center mt-[4rem] mb-[17rem] text-[#ebebeb]">
            <div className="text-[14rem]">
              <a
                href="https://www.shengli.com/prot/Index.html"
                target="_blank"
                className="underline"
                rel="noreferrer noopener"
              >
                适龄提示：本游戏适合16岁（含）以上玩家娱乐
              </a>
            </div>
            <div className="ml-[38rem]">
              <div className="text-[14rem]">
                <a
                  href="https://cdnserver.cmge.com/service/xjsj/privacy_ZSY.html"
                  target="_blank"
                  className="underline"
                  rel="noreferrer noopener"
                >
                  隐私政策
                </a>
                <span> / </span>
                <a
                  href="https://cdnserver.cmge.com/service/xjsj/serviece_ZSY.html"
                  target="_blank"
                  className="underline"
                  rel="noreferrer noopener"
                >
                  用户服务协议
                </a>
              </div>
            </div>
            <div className="flex items-center ml-[40rem]">
              <div className="w-[34rem] h-[37rem] mr-[16rem]">
                {/* <img
                  className="w-full h-full"
                  src="/images/copyright-section/gs.png"
                  width={34}
                  height={37}
                  alt="gs"
                /> */}
                <div className="gsj w-[34rem] h-[37rem]"></div>
              </div>
              <div className="text-[14rem]">
                <p>工商网监电子标识</p>
              </div>
            </div>
          </div>
          {/* 描述 */}
          <div className="text-[#464646] text-[14rem]  text-left">
            <p>上海凡影网络科技有限公司 未成年人家长监护工程体系</p>
            <p>
              我公司对本网站产品、服务、信息、材料等一切内容享有全部知识产权。
            </p>
            <p>
              任何第三方不得利用本网站内容获取收益或以任何方式侵犯我公司权利，否则我公司将依法追究其法律责任，
            </p>
          </div>
        </div>
        {/* 右 */}
        <div className="flex-1 w-auto h-auto text-end relative">
          {/* copyright */}
          <div className="text-[#ebebeb]  flex justify-end items-center gap-[20rem]">
            <div className="xianjian w-[120rem] h-[26rem] relative cursor-pointer">
              <div className="game_list absolute shadow-sm stand-down  left-1/2 -translate-x-1/2 bottom-[100%] w-[284rem] h-[364rem] z-10 cursor-default">
                <div className="relative overflow-hidden select-none w-full h-full">
                  <img
                    alt={process.env.PUBLIC_URL + '/images/stand-link-bg.png'}
                    draggable="false"
                    loading="lazy"
                    width="284"
                    height="364"
                    decoding="async"
                    data-nimg="1"
                    className="fit_parent pointer-events-none object-contain transition-opacity duration-300 data-[loaded=false]:animate-pulse data-[loaded=false]:bg-gray-100/10"
                    src={process.env.PUBLIC_URL + '/images/stand-link-bg.png'}
                    data-loaded="true"
                  />
                  <ul className="stand-down-list fit_parent flex flex-col justify-between text-left p-[20rem] ">
                    <li className="stand-down-item">
                      <a
                        target="_blank"
                        href="http://pal1.roogames.com/"
                        className="stand-down-link"
                        rel="noreferrer noopener"
                      >
                        《仙剑奇侠传》
                      </a>
                    </li>
                    <li className="stand-down-item">
                      <a
                        target="_blank"
                        href="http://pal2.roogames.com/"
                        className="stand-down-link"
                        rel="noreferrer noopener"
                      >
                        《仙剑奇侠传二》
                      </a>
                    </li>
                    <li className="stand-down-item">
                      <a
                        target="_blank"
                        href="http://pal3.roogames.com/"
                        className="stand-down-link"
                        rel="noreferrer noopener"
                      >
                        《仙剑奇侠传三》
                      </a>
                    </li>
                    <li className="stand-down-item">
                      <a
                        target="_blank"
                        href="http://pal3w.roogames.com/"
                        className="stand-down-link"
                        rel="noreferrer noopener"
                      >
                        《仙剑奇侠传三外传·问情篇》
                      </a>
                    </li>
                    <li className="stand-down-item">
                      <a
                        target="_blank"
                        href="http://pal5.baiyou100.com/2401000.asp"
                        className="stand-down-link"
                        rel="noreferrer noopener"
                      >
                        《仙剑奇侠传四》
                      </a>
                    </li>
                    <li className="stand-down-item">
                      <a
                        target="_blank"
                        href="http://pal5.baiyou100.com/"
                        className="stand-down-link"
                        rel="noreferrer noopener"
                      >
                        《仙剑奇侠传五》
                      </a>
                    </li>
                    <li className="stand-down-item">
                      <a
                        target="_blank"
                        href="http://pal5.baiyou100.com/2501000.asp"
                        className="stand-down-link"
                        rel="noreferrer noopener"
                      >
                        《仙剑奇侠传五前传》
                      </a>
                    </li>
                    <li className="stand-down-item">
                      <a
                        target="_blank"
                        href="http://pal6.pcjoy.cn/"
                        className="stand-down-link"
                        rel="noreferrer noopener"
                      >
                        《仙剑奇侠传六》
                      </a>
                    </li>
                    <li className="stand-down-item">
                      <a
                        target="_blank"
                        href="http://pal7.cubejoy.com/"
                        className="stand-down-link"
                        rel="noreferrer noopener"
                      >
                        《仙剑奇侠传七》
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <p className="text-[24rem]">COPYRIGHT</p>
          </div>

          <div className="leading-loose text-[#464646] text-[14em]">
            <p>◎深圳市中手游网络科技有限公司 版权所有</p>
            <p>深圳市福田区中康北路卓越梅林中心广场（北区） 4号楼08层-10层</p>
            <p>网站备案/许可证号：粤ICP备15071109号</p>
            <p>网络服务出版许可证：（总）网出证（粤）字第003号</p>
            <p>增值电信经营许可证：粤B2-20150479</p>
          </div>
        </div>
      </div>
    </section>
  );
}
